import {_User as User} from "./_User";

export const SmartPackageAPI = {
    User: User
};